import  gql  from 'graphql-tag'

export const CREATE_CONTINGENT_QUOTA_AGRO = gql`mutation contingentQuotaTdcAgro($input: ContingentQuotaTDCAgroMutationInput!){
    contingentQuotaTdcAgro(input: $input){
        contingentQuotaTDCAgro{
            id
            data
        }
        errors{
            field
            messages
        }
    }
}`;